import { HttpService } from '../../common/http.service';
import {
  getDoctorsEndPoint,
  placeAPSOrderEndPoint,
  placeEhrOrderEndPoint,
  placeLabPiqOrderEndPoint,
  searchDoctorsEndPoint,
} from './endpoints';
import { Doctor, DoctorFormData } from './types';

export async function fetchDoctors(
  applicationId: number,
  taskId: number,
): Promise<Doctor[]> {
  try {
    const data = await HttpService.getInstance().get(
      getDoctorsEndPoint(applicationId, taskId),
    );
    if (data && !data.error) return data.parsedBody;
    return [];
  } catch (error) {
    console.error('Error fetching doctors:', error);
    return [];
  }
}

export async function searchDoctors(
  applicationId: number,
  taskId: number,
  query: string,
): Promise<Doctor[]> {
  try {
    const data = await HttpService.getInstance().get(
      searchDoctorsEndPoint(applicationId, taskId, query),
    );
    if (data && !data.error) return data.parsedBody;
    return [];
  } catch (error) {
    console.error('Error searching doctors:', error);
    return [];
  }
}

export async function placeAPSOrder(
  applicationId: number,
  taskId: number,
  formData: DoctorFormData,
) {
  const response = await HttpService.getInstance().post(
    placeAPSOrderEndPoint(applicationId, taskId),
    formData,
  );

  // Check if HTTP error occurred (HttpService returns { error } on HTTP errors)
  if (response && response.error) {
    const errorMessage =
      response.error.message || response.message || 'Failed to place APS order';
    throw new Error(errorMessage);
  }

  return response;
}

export async function placeEHROrder(applicationId: number, taskId: number) {
  const response = await HttpService.getInstance().post(
    placeEhrOrderEndPoint(applicationId, taskId),
    {},
  );

  // Check if HTTP error occurred (HttpService returns { error } on HTTP errors)
  if (response && response.error) {
    const errorMessage =
      response.error.message || response.message || 'Failed to place EHR order';
    throw new Error(errorMessage);
  }

  return response;
}

export async function placeLabPiqOrder(applicationId: number, taskId: number) {
  const response = await HttpService.getInstance().post(
    placeLabPiqOrderEndPoint(applicationId, taskId),
    {},
  );

  // Check if HTTP error occurred (HttpService returns { error } on HTTP errors)
  if (response && response.error) {
    const errorMessage =
      response.error.message ||
      response.message ||
      'Failed to place LibPiq order';
    throw new Error(errorMessage);
  }

  return response;
}
